export default function() {
  return {
    favorites: {
      devices: [],
      items: [],
      rules: []
    }
  };
}
